import { useQuery } from '@tanstack/react-query';
import { useCompany } from '@/contexts/CompanyContext';
import { useDirection } from '@/contexts/DirectionContext';
import { vesselDeparturesApi } from '../api/vesselDepartures.api';
import type { PortDeparturesRow } from '../interfaces/vesselDepartures.interface';

interface UseVesselDeparturesResult {
  data: PortDeparturesRow[] | undefined;
  isLoading: boolean;
  isFetching: boolean;
  error: Error | null;
  refresh: () => void;
}

export function useVesselDepartures(): UseVesselDeparturesResult {
  const { selectedCompanyId } = useCompany();
  const { direction } = useDirection();
  const companyId = typeof selectedCompanyId === 'number' ? selectedCompanyId : undefined;

  const query = useQuery<PortDeparturesRow[]>({
    queryKey: ['dashboard', 'vessel-departures', selectedCompanyId, direction],
    queryFn: () => vesselDeparturesApi.get(companyId, direction),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: (query.error as Error) || null,
    refresh: () => {
      void query.refetch();
    },
  };
}
